export enum ClosedReason {
  COMPLETED = "COMPLETED",
  VOIDED = "VOIDED",
}
